import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login')
  },
  {
    path: '/',
    name: 'index',
    component: index
  },
  //搜索
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/search')
  },
  //代购订单列表
  {
    path: '/dgOrder',
    name: 'dgOrder',
    component: () => import('../views/dgOrder/orderList')
  },
  {
    path: '/dgOrderContent',
    name: 'dgOrderContent',
    component: () => import('../views/dgOrder/orderContent')
  },
  //取件订单列表
  {
    path: '/qjOrder',
    name: 'qjOrder',
    component: () => import('../views/qjOrder/orderList')
  },
  {
    path: '/qjOrderContent',
    name: 'qjOrderContent',
    component: () => import('../views/qjOrder/orderContent')
  },
  //寄件订单列表
  {
    path: '/jjOrder',
    name: 'jjOrder',
    component: () => import('../views/jjOrder/orderList')
  },
  {
    path: '/jjOrderContent',
    name: 'jjOrderContent',
    component: () => import('../views/jjOrder/orderContent')
  },
/*-------------------------多购运营商----------------------------------------------------------*/


  //微信第一次登陆页面
  {
    path: '/webLogin',
    name: 'webLogin',
    component: () => import('../views/webLogin')
  },
    //商家主页
  {
    path: '/shopsInfo',
    name: 'shopsInfo',
    component: () => import('../views/ddPartner/shopsInfo')
  },
    //设置
  {
    path: '/setting',
    name: 'setting',
    component:() => import('../views/ddPartner/setting/index')
  },
  /*总订单列表*/
  {
    path: '/allOrder',
    name: 'allOrder',
    component: () => import('../views/ddPartner/allOrder/orderList')
  },
  {
    path: '/allOrderContent',
    name: 'allOrderContent',
    component: () => import('../views/ddPartner/allOrder/orderContent')
  },
  /*子订单列表*/
  {
    path: '/childOrder',
    name: 'childOrder',
    component: () => import('../views/ddPartner/childOrder/orderList')
  },
  {
    path: '/childOrderContent',
    name: 'childOrderContent',
    component: () => import('../views/ddPartner/childOrder/orderContent')
  }


]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
